import { Box, Grid, LinearProgress, Typography } from '@mui/material'
import clsx from "clsx";
import React from 'react'
import styles from "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import IconsColor from '../../../components/utility/iconsColor';
import globalStyles from "../../../assets/styles/global.module.scss";
import { currentActiveThreadChatbotThreadData } from '../../../models/axiosModel';
import BotMessage from './botMessage';
import UserMessage from './userMessage';
import { useRuleBasedInboxStore } from '../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import { getDynamicColorsBySource } from '../../../pages/ruleBasedInbox/utils';
import { USER_MESSAGE_ACTION_TYPES } from '../constants';
import SystemMessage, { getCenterSystemMessageState } from './systemMessage';

interface ThreadMessageProps {
    getDynamicColorsByChatbotRouteSource: (source?: string) => ReturnType<typeof getDynamicColorsBySource>;
    getSteps: (ai_execution_id: string) => void | Promise<void>;
    getSubChatbotExceutionLog: (ai_execution_id: string) => void | Promise<void>;
    handleExecutionTimeLog: (thread: currentActiveThreadChatbotThreadData) => void;
    targetRef: React.RefObject<HTMLElement | null>;
}

const ThreadMessage = (props: ThreadMessageProps) => {

    const { getDynamicColorsByChatbotRouteSource, getSteps, getSubChatbotExceutionLog, handleExecutionTimeLog, targetRef } = props;

    const { currentActiveChatbotThread, filteredData, subType, flagLoadingPreviousMessages, flagRenderNewConversation } = useRuleBasedInboxStore(
        useShallow((state) => ({
            currentActiveChatbotThread: state.currentActiveChatbotThread,
            filteredData: state.filteredData,
            subType: state.subType,
            flagLoadingPreviousMessages: state.flagLoadingPreviousMessages,
            flagRenderNewConversation: state.flagRenderNewConversation,
        }))
    );

    const getQuotedThread = (thread: currentActiveThreadChatbotThreadData) => {
        return currentActiveChatbotThread?.chatbot_thread_data?.find((initialThread: currentActiveThreadChatbotThreadData) => initialThread?.thread_execution_log_id == thread?.parent_thread_execution_log_id)
    }

    const renderNoConversationGrid = (text: string) => {
        return (
            <Grid container className={clsx(globalStyles.fullHeight, globalStyles.centerAlignment)} direction={"column"}>
                <Grid item>
                    <IconsColor iconName="chats" width="62px" height="62px" fillColor="#7A7A7A" />
                </Grid>
                <Grid item sx={{ color: getDynamicColorsByChatbotRouteSource().no_conversation_color }}>
                    <Typography className={clsx(globalStyles.primaryFontSize, globalStyles.primaryFontWeight)}>
                        {text}
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            {flagLoadingPreviousMessages &&
                <>
                    <Grid item className={styles.fetchingPreviousMessagesGrid}>
                        <Box className={styles.fetchingPreviousMessagesBox}>
                            <Typography variant="body2" className={styles.fetchingPreviousMessagesTypography}>
                                Fetching previous messages...
                            </Typography>
                            <LinearProgress className={styles.fetchingPreviousMessagesProgress} />
                        </Box>
                    </Grid>
                </>
            }
            {(currentActiveChatbotThread !== null && currentActiveChatbotThread?.chatbot_thread_data?.length > 0 && currentActiveChatbotThread?.chatbot_thread_data[0].chatbot_thread_id !== "") ?

                currentActiveChatbotThread ? currentActiveChatbotThread?.chatbot_thread_data?.map((thread: currentActiveThreadChatbotThreadData, ind: number) => {

                    const isBot = thread?.flag_user_message == false
                    const actionTypeName = thread?.action_type_name?.toLowerCase() ?? "";
                    const centerSystemMsgState = getCenterSystemMessageState(thread);

                    if (centerSystemMsgState.isMiscTypeText) return null;

                    const flag_show_action = thread?.flag_show_action ?? false;
                    const aiMessageExecutionActionType = actionTypeName === USER_MESSAGE_ACTION_TYPES['AI_MESSAGE_EXECUTION']?.toLowerCase();

                    return (
                        <React.Fragment key={ind}>
                            {flag_show_action &&
                                <>
                                    {centerSystemMsgState.shouldRenderMessagesInCenter ?
                                        <SystemMessage
                                            thread={thread}
                                            agentChipBgColor={getDynamicColorsByChatbotRouteSource().agent_chip_bg_color}
                                            state={centerSystemMsgState}
                                        />
                                        :
                                        isBot ? 
                                            <BotMessage
                                                thread={thread}
                                                ind={ind}
                                                targetRef={targetRef}
                                                aiMessageExecutionActionType={aiMessageExecutionActionType}
                                                getQuotedThread={getQuotedThread}
                                            />
                                            : 
                                            <UserMessage
                                                thread={thread}
                                                ind={ind}
                                                targetRef={targetRef}
                                                aiMessageExecutionActionType={aiMessageExecutionActionType}
                                                getQuotedThread={getQuotedThread}
                                                getDynamicColorsByChatbotRouteSource={getDynamicColorsByChatbotRouteSource}
                                                getSteps={getSteps}
                                                getSubChatbotExceutionLog={getSubChatbotExceutionLog}
                                                handleExecutionTimeLog={handleExecutionTimeLog}
                                            />
                                    }
                                </>
                            }
                        </React.Fragment>
                    )
                }) : ""
                :
                !flagRenderNewConversation &&
                <>
                    {subType == 'Active' ?
                        filteredData?.activeChats?.length == 0 ?
                            renderNoConversationGrid("No Conversation here yet.")
                            :
                            !currentActiveChatbotThread &&
                            renderNoConversationGrid("No Conversation selected yet.")
                        :
                        filteredData?.closedChats?.length == 0 ?
                            renderNoConversationGrid("No Conversation here yet.")
                            :
                            !currentActiveChatbotThread &&
                            renderNoConversationGrid("No Conversation selected yet.")
                            
                    }
                </>
            }
        </>
    );
}

export default ThreadMessage;
